import { render, staticRenderFns } from "./KiraKiraPack02.vue?vue&type=template&id=06bbdb2c&scoped=true&"
import script from "./KiraKiraPack02.vue?vue&type=script&lang=js&"
export * from "./KiraKiraPack02.vue?vue&type=script&lang=js&"
import style0 from "./KiraKiraPack02.vue?vue&type=style&index=0&id=06bbdb2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bbdb2c",
  null
  
)

export default component.exports